import { useSyncExternalStore } from "react";

/**
 * 私有化实例「授权只读」信号(OEM W5-con-private)。
 *
 * 置位来源:
 *   · httpClient:任何接口回 LICENSE_READONLY(423)→ markLicenseReadonly(true);
 *   · 授权页 / 侧栏探针:GET /platform/license 的 status.mode 为 READONLY / OK 时同步置位 / 清除。
 * 消费:widgets/LicenseReadonlyBanner 全站顶部横幅。
 *
 * ★只放内存:刷新后要等下一次写请求被 423(或平台超管的授权探针)才会再亮 —— 只读期 GET 全放行,
 *   用户在不写的时候本来就不受影响;持久化反而会在换好 license 后残留一条假横幅。
 */
let readonly = false;
const listeners = new Set<() => void>();

export function markLicenseReadonly(v: boolean): void {
  if (readonly === v) return;
  readonly = v;
  for (const l of listeners) l();
}

export function isLicenseReadonly(): boolean {
  return readonly;
}

export function subscribeLicenseReadonly(l: () => void): () => void {
  listeners.add(l);
  return () => {
    listeners.delete(l);
  };
}

export function useLicenseReadonly(): boolean {
  return useSyncExternalStore(subscribeLicenseReadonly, isLicenseReadonly, isLicenseReadonly);
}

/** 后端只读闸的错误码(LicenseGuardFilter.CODE)。 */
export const LICENSE_READONLY_CODE = "LICENSE_READONLY";
